import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import Select from 'react-select'
import Button from '@material-ui/core/Button'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import getLoginId from '../../../utils/getLoginId'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'

const styles = theme => ({
  root: {
    padding: 24,
    marginTop: 24
  },
  paper: {
    padding: 24,
    marginBottom: 16,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  selectBox: {
    width: '100%'
  },
  button: {
    margin: theme.spacing.unit,
  },
  existingSubscriptionCard: {
    padding: 16,
    marginBottom: 16,
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    textAlign: 'left'
  },
  subscriptionHeader: {
    fontWeight: 'bold',
    marginBottom: 8,
    color: theme.palette.primary.main
  },
  sectionTitle: {
    marginBottom: 16,
    textAlign: 'left',
    fontWeight: 'bold',
    color: theme.palette.primary.main
  },
  tabPaper: {
    padding: '32px 24px',
    marginBottom: 16,
    borderRadius: 8,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
  },
  gridHeader: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    color: '#333',
    height: '100%'
  },
  fieldGroup: {
    padding: '8px 0'
  },
  fieldLabel: {
    fontSize: '0.85rem',
    color: '#666',
    marginBottom: 8,
    fontWeight: 600
  },
  readoutBox: {
    backgroundColor: '#e3f2fd', // Light blue from screenshot
    padding: '12px 16px',
    borderRadius: 4,
    border: '1px solid #bbdefb',
    fontSize: '0.95rem',
    color: '#1976d2',
    fontWeight: 500,
    minHeight: 48,
    display: 'flex',
    alignItems: 'center'
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    margin: '24px 0'
  },
  shiftButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 24
  }
})

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const GET_VEHICLES = gql`
  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {
    vehicles: getAllVehicleDetailsByStatus(
      partnerLoginId: $loginId
      status: $status
    ) {
      entityId
      vehicleNumber
      clientLoginId
      status
      deviceDetail {
        uniqueDeviceId
      }
      solutionType
    }
  }
`

const DEVICE_SHIFT_MUTATION = gql`
  mutation DeviceShiftOnbaording($solutionType: String!, $customerType: String!, $sourceUniqueId: String, $targetUniqueId: String, $sourceCustomerId: Int, $targetCustomerId: Int, $sourceentityid: Int, $targetentityid: Int, $created_by: String, $updated_by: String) {
    deviceShiftOnbaording(solutionType: $solutionType, customerType: $customerType, sourceUniqueId: $sourceUniqueId, targetUniqueId: $targetUniqueId, sourceCustomerId: $sourceCustomerId, targetCustomerId: $targetCustomerId, sourceentityid: $sourceentityid, targetentityid: $targetentityid, created_by: $created_by, updated_by: $updated_by) {
      success
      message
    }
  }
`

class DeviceShift extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shiftMode: 'same', // 'same' or 'different'
      selectedCustomer: null,
      selectedTargetCustomer: null,
      selectedSourceVehicle: null,
      selectedTargetVehicle: null,
      isSubmitting: false,
      confirmDialogOpen: false,
      confirmDialogMessage: '',
      confirmDialogTitle: '',
      pendingAction: null
    }
  }

  handleShiftModeChange = (event, shiftMode) => {
    if (!shiftMode) return
    this.setState({
      shiftMode,
      selectedCustomer: null,
      selectedTargetCustomer: null,
      selectedSourceVehicle: null,
      selectedTargetVehicle: null
    })
  }

  handleCustomerChange = selectedCustomer => {
    this.setState({ selectedCustomer, selectedSourceVehicle: null })
  }

  handleTargetCustomerChange = selectedTargetCustomer => {
    this.setState({ selectedTargetCustomer })
  }

  handleSourceVehicleChange = selectedSourceVehicle => {
    this.setState({ selectedSourceVehicle })
  }

  handleTargetVehicleChange = selectedTargetVehicle => {
    this.setState({ selectedTargetVehicle })
  }

  // handleSolutionTypeChange removed

  submitDeviceShift = async () => {
    const {
      shiftMode,
      selectedCustomer,
      selectedTargetCustomer,
      selectedSourceVehicle,
      selectedTargetVehicle,
    } = this.state
    const solutionType = selectedSourceVehicle && selectedSourceVehicle.solutionType
    if (!solutionType) {
      this.props.openSnackbar('Source vehicle has no solution type associated')
      return
    }

    const sourceUniqueId = selectedSourceVehicle && selectedSourceVehicle.deviceDetail && selectedSourceVehicle.deviceDetail.uniqueDeviceId
    const targetUniqueId = selectedTargetVehicle && selectedTargetVehicle.deviceDetail && selectedTargetVehicle.deviceDetail.uniqueDeviceId

    if (shiftMode === 'same') {
      if (!sourceUniqueId || !targetUniqueId) {
        this.props.openSnackbar('Both source and target vehicles must have devices')
        return
      }
      if (!selectedCustomer) {
        this.props.openSnackbar('Please select a customer')
        return
      }
      if (!selectedSourceVehicle || !selectedTargetVehicle) {
        this.props.openSnackbar('Please select both source and target vehicles')
        return
      }
    } else {
      if (!sourceUniqueId) {
        this.props.openSnackbar('Source vehicle must have a device')
        return
      }
      if (!selectedCustomer || !selectedTargetCustomer) {
        this.props.openSnackbar('Please select both source and target customers')
        return
      }
      if (!selectedSourceVehicle) {
        this.props.openSnackbar('Please select a source vehicle')
        return
      }
    }

    let confirmMessage = ''
    if (shiftMode === 'same') {
      confirmMessage = `Are you sure you want to shift device from ${selectedSourceVehicle.vehicleNumber} to ${selectedTargetVehicle.vehicleNumber}?`
    } else {
      confirmMessage = `Are you sure you want to shift device from ${selectedSourceVehicle.vehicleNumber} (customer: ${selectedCustomer.label}) to the target customer ${selectedTargetCustomer.label}?`
    }

    this.setState({
      confirmDialogOpen: true,
      confirmDialogTitle: 'Confirm Device Shift',
      confirmDialogMessage: confirmMessage,
      pendingAction: 'shift'
    })
  }

  executeDeviceShift = async () => {
    const {
      shiftMode,
      selectedCustomer,
      selectedTargetCustomer,
      selectedSourceVehicle,
      selectedTargetVehicle
    } = this.state

    const solutionType = selectedSourceVehicle && selectedSourceVehicle.solutionType
    const sourceUniqueId = selectedSourceVehicle && selectedSourceVehicle.deviceDetail && selectedSourceVehicle.deviceDetail.uniqueDeviceId
    let targetUniqueId = null
    let targetEntityId = null
    let targetCustomerId = null

    if (shiftMode === 'same') {
      targetUniqueId = selectedTargetVehicle && selectedTargetVehicle.deviceDetail && selectedTargetVehicle.deviceDetail.uniqueDeviceId
      targetEntityId = selectedTargetVehicle && selectedTargetVehicle.entityId
      targetCustomerId = selectedCustomer && selectedCustomer.value
    } else {
      targetUniqueId = null
      targetEntityId = null
      targetCustomerId = selectedTargetCustomer && selectedTargetCustomer.value
    }

    this.setState({ isSubmitting: true, confirmDialogOpen: false })

    try {
      const { data } = await this.props.client.mutate({
        mutation: DEVICE_SHIFT_MUTATION,
        variables: {
          sourceUniqueId,
          targetUniqueId,
          solutionType,
          customerType: shiftMode,
          sourceCustomerId: selectedCustomer && selectedCustomer.value,
          targetCustomerId: targetCustomerId,
          sourceentityid: selectedSourceVehicle && selectedSourceVehicle.entityId,
          targetentityid: targetEntityId,
          created_by: localStorage.getItem('username'),
          updated_by: localStorage.getItem('username')
        },
        errorPolicy: 'all'
      })

      const response = data && data.deviceShiftOnbaording
      
      this.props.openSnackbar(
        response && response.message
          ? response.message
          : 'Device shift completed successfully'
      )

      if (response && response.success) {
        // Reset form only on success
        this.setState({
          selectedCustomer: null,
          selectedTargetCustomer: null,
          selectedSourceVehicle: null,
          selectedTargetVehicle: null
        })
      }
    } catch (e) {
      console.error(e)
      this.props.openSnackbar('Failed to shift device')
    } finally {
      this.setState({ isSubmitting: false })
    }
  }

  closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
  }

  render() {
    const { classes } = this.props
    const {
      shiftMode,
      selectedCustomer,
      selectedTargetCustomer,
      selectedSourceVehicle,
      selectedTargetVehicle,
      isSubmitting,
      confirmDialogOpen,
      confirmDialogMessage,
      confirmDialogTitle
    } = this.state
    const partnerLoginId = getLoginId()

    return (
      <div className={classes.root}>
        <Typography variant="h4" component="h1" gutterBottom className={classes.sectionTitle}>
          Device Shift
        </Typography>

        {/* Tabs Selection */}
        <Paper className={classes.paper} style={{ padding: 0, overflow: 'hidden', marginBottom: 24 }}>
          <Tabs
            value={shiftMode}
            onChange={this.handleShiftModeChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab value="same" label="Same Customer" />
            <Tab value="different" label="Different Customer" />
          </Tabs>
        </Paper>

        {/* Same Customer Tab Content */}
        {shiftMode === 'same' && (
          <Paper className={classes.tabPaper}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={3}>
                <div className={classes.gridHeader}>Customer & Vehicle</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.fieldLabel}>Customer *</div>
                <Query query={GET_CLIENTS} variables={{ partnerLoginId }}>
                  {({ loading, error, data }) => {
                    if (loading) return <div>Loading...</div>
                    if (error) return <div>Error loading customers</div>

                    const customerOptions = (data.clients || []).map(
                      client => ({
                        value: client.loginId,
                        label: client.clientName,
                        ...client
                      })
                    )

                    return (
                      <Select
                        value={selectedCustomer}
                        onChange={this.handleCustomerChange}
                        options={customerOptions}
                        placeholder="Select a customer"
                        className={classes.selectBox}
                      />
                    )
                  }}
                </Query>
              </Grid>
              <Grid item xs={12} md={5}>
                <div className={classes.fieldLabel}>Source Vehicle *</div>
                <Query
                  query={GET_VEHICLES}
                  variables={{ loginId: partnerLoginId, status: 1 }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <Select placeholder="Loading..." disabled />
                    if (error) return <div>Error loading vehicles</div>

                    const filteredVehicles = (data.vehicles || []).filter(
                      v => v && v.clientLoginId === (selectedCustomer ? selectedCustomer.value : null)
                    )

                    const vehicleOptions = filteredVehicles.map(
                      vehicle => ({
                        value: vehicle.entityId,
                        label: vehicle.vehicleNumber,
                        ...vehicle
                      })
                    )

                    return (
                      <Select
                        value={selectedSourceVehicle}
                        onChange={this.handleSourceVehicleChange}
                        options={vehicleOptions}
                        placeholder="Select source vehicle"
                        className={classes.selectBox}
                        disabled={!selectedCustomer}
                      />
                    )
                  }}
                </Query>
              </Grid>
            </Grid>

            <Grid container spacing={4} style={{ marginTop: 8 }}>
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} md={9}>
                <div className={classes.fieldLabel}>Source vehicle device id</div>
                <div className={classes.readoutBox}>
                  {selectedSourceVehicle && selectedSourceVehicle.deviceDetail
                    ? `${selectedSourceVehicle.deviceDetail.uniqueDeviceId} ${selectedSourceVehicle.solutionType ? `(${selectedSourceVehicle.solutionType.toUpperCase()})` : ''}`
                    : 'No device associated'}
                </div>
              </Grid>
            </Grid>

            <div className={classes.divider} />

            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={3}>
                <div className={classes.gridHeader}>Target Vehicle</div>
              </Grid>
              <Grid item xs={12} md={4}></Grid>
              <Grid item xs={12} md={5}>
                <div className={classes.fieldLabel}>Target Vehicle *</div>
                <Query
                  query={GET_VEHICLES}
                  variables={{ loginId: partnerLoginId, status: 1 }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <Select placeholder="Loading..." disabled />
                    if (error) return <div>Error loading vehicles</div>

                    const filteredVehicles = (data.vehicles || []).filter(
                      v => v && v.clientLoginId === (selectedCustomer ? selectedCustomer.value : null)
                    )

                    const vehicleOptions = filteredVehicles.map(
                      vehicle => ({
                        value: vehicle.entityId,
                        label: vehicle.vehicleNumber,
                        ...vehicle
                      })
                    )

                    return (
                      <Select
                        value={selectedTargetVehicle}
                        onChange={this.handleTargetVehicleChange}
                        options={vehicleOptions}
                        placeholder="Select target vehicle"
                        className={classes.selectBox}
                        disabled={!selectedCustomer}
                      />
                    )
                  }}
                </Query>
              </Grid>
            </Grid>

            {selectedCustomer && selectedSourceVehicle && selectedTargetVehicle && (
              <div className={classes.shiftButtonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={isSubmitting}
                  onClick={this.submitDeviceShift}
                  className={classes.button}
                >
                  {isSubmitting ? 'Processing...' : 'Shift'}
                </Button>
              </div>
            )}
          </Paper>
        )}

        {/* Different Customer Tab Content */}
        {shiftMode === 'different' && (
          <Paper className={classes.tabPaper}>
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={3}>
                <div className={classes.gridHeader}>Source Customer & Vehicle</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.fieldLabel}>Source Customer *</div>
                <Query query={GET_CLIENTS} variables={{ partnerLoginId }}>
                  {({ loading, error, data }) => {
                    if (loading) return <div>Loading...</div>
                    if (error) return <div>Error loading customers</div>

                    const customerOptions = (data.clients || []).map(
                      client => ({
                        value: client.loginId,
                        label: client.clientName,
                        ...client
                      })
                    )

                    return (
                      <Select
                        value={selectedCustomer}
                        onChange={this.handleCustomerChange}
                        options={customerOptions}
                        placeholder="Select source customer"
                        className={classes.selectBox}
                      />
                    )
                  }}
                </Query>
              </Grid>
              <Grid item xs={12} md={5}>
                <div className={classes.fieldLabel}>Source Vehicle *</div>
                <Query
                  query={GET_VEHICLES}
                  variables={{ loginId: partnerLoginId, status: 1 }}
                >
                  {({ loading, error, data }) => {
                    if (loading) return <Select placeholder="Loading..." disabled />
                    if (error) return <div>Error loading vehicles</div>

                    const filteredVehicles = (data.vehicles || []).filter(
                      v => v && v.clientLoginId === (selectedCustomer ? selectedCustomer.value : null)
                    )

                    const vehicleOptions = filteredVehicles.map(
                      vehicle => ({
                        value: vehicle.entityId,
                        label: vehicle.vehicleNumber,
                        ...vehicle
                      })
                    )

                    return (
                      <Select
                        value={selectedSourceVehicle}
                        onChange={this.handleSourceVehicleChange}
                        options={vehicleOptions}
                        placeholder="Select source vehicle"
                        className={classes.selectBox}
                        disabled={!selectedCustomer}
                      />
                    )
                  }}
                </Query>
              </Grid>
            </Grid>

            <Grid container spacing={4} style={{ marginTop: 8 }}>
              <Grid item xs={12} md={3}></Grid>
              <Grid item xs={12} md={9}>
                <div className={classes.fieldLabel}>Source Vehicle Device ID</div>
                <div className={classes.readoutBox}>
                  {selectedSourceVehicle && selectedSourceVehicle.deviceDetail
                    ? `${selectedSourceVehicle.deviceDetail.uniqueDeviceId} ${selectedSourceVehicle.solutionType ? `(${selectedSourceVehicle.solutionType.toUpperCase()})` : ''}`
                    : 'No device associated'}
                </div>
              </Grid>
            </Grid>

            <div className={classes.divider} />

            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={3}>
                <div className={classes.gridHeader}>Target Customer</div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.fieldLabel}>Target Customer *</div>
                <Query query={GET_CLIENTS} variables={{ partnerLoginId }}>
                  {({ loading, error, data }) => {
                    if (loading) return <div>Loading...</div>
                    if (error) return <div>Error loading customers</div>

                    const customerOptions = (data.clients || []).map(
                      client => ({
                        value: client.loginId,
                        label: client.clientName,
                        ...client
                      })
                    )

                    return (
                      <Select
                        value={selectedTargetCustomer}
                        onChange={this.handleTargetCustomerChange}
                        options={customerOptions}
                        placeholder="Select target customer"
                        className={classes.selectBox}
                      />
                    )
                  }}
                </Query>
              </Grid>
              {/* Target vehicle column omitted */}
            </Grid>

            {selectedCustomer && selectedTargetCustomer && selectedSourceVehicle && (
              <div className={classes.shiftButtonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={isSubmitting}
                  onClick={this.submitDeviceShift}
                  className={classes.button}
                >
                  {isSubmitting ? 'Processing...' : 'Shift'}
                </Button>
              </div>
            )}
          </Paper>
        )}

        {/* Confirm Dialog */}
        <ConfirmationalDialog
          isDialogOpen={confirmDialogOpen}
          dialogTitle={confirmDialogTitle}
          dialogMessage={confirmDialogMessage}
          positiveResponseButtonText="Yes"
          negativeResponseButtonText="No"
          positiveResponseHandler={this.executeDeviceShift}
          negativeResponseHandler={this.closeConfirmDialog}
          dialogCloseHandler={this.closeConfirmDialog}
        />
      </div>
    )
  }
}

export default withStyles(styles)(withApollo(withSharedSnackbar(DeviceShift)))



// WEBPACK FOOTER //
// ./src/components/Pages/DeviceShift/index.jsx